export default {
  name: 'gmk-olivetti',
  override: {
    KC_ESC: 'accent',
    KC_ENT: 'accent'
  }
};
